import React, { useEffect, useState, useCallback } from "react";
import { useRouter } from "../../hooks/router";
import { Container, Title } from "./styles";
import { producaov2 as api } from "../../services/apis";
import ProjetosTable from "./components/ProjetosTable";
import Controls from "./components/Controls";

const ControleProjetos = (props) => {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [item, setItem] = useState(props.item || 0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [subitens, setSubitens] = useState([]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const doSearches = useCallback(() => {
    const params = {};

    if (year) {
      params.year = year;
    }

    if (item) {
      params.item = item;
    }

    if (status) {
      params.status = status;
    }

    if (page) {
      params.page = page;
    }

    if (search) {
      params.search = search;
    }

    api
      .get("admin/relatorio-subitens/get-pedidos-from-json", {
        params,
      })
      .then((res) => {
        const { subitens, pages } = res.data.response;

        console.log("SUBITENS:::", subitens);

        setSubitens(subitens);
        setPages(pages);
      });
  }, [year, item, status, page, search]);

  const cleanSearches = useCallback(() => {
    setSearch("");
  }, []);

  const handleVirar = useCallback(
    (dataPed, id_pedido) => {
      const index = subitens
        .map((subitem, index) =>
          subitem.dataPed === dataPed && subitem.id_pedido === id_pedido
            ? index
            : -1
        )
        .find((index) => index > -1);

      const newSubitens = [...subitens];

      if (newSubitens[index].statusPagamento === "Pago") {
        return;
      }

      newSubitens[index].statusPagamento = "Pago";
      setSubitens(newSubitens);

      const params = {
        date: dataPed,
        id_pedido,
      };

      api.put(
        "admin/relatorio-subitens/update-pedido-from-json",
        {
          statusPagamento: true,
        },
        { params }
      );
    },
    [subitens]
  );

  useEffect(() => {
    doSearches();
  }, [year, item, status, page]);

  return (
    <Container>
      <Title>Controle de Subitens</Title>

      <Controls
        page={page}
        pages={pages}
        search={search}
        item={item}
        status={status}
        year={year}
        setItem={setItem}
        setStatus={setStatus}
        setSearch={setSearch}
        setYear={setYear}
        cleanSearches={cleanSearches}
        doSearches={doSearches}
        handleChange={handleChange}
      />

      <ProjetosTable subitens={subitens} handleVirar={handleVirar} />

      <Controls
        page={page}
        pages={pages}
        search={search}
        item={item}
        status={status}
        year={year}
        setItem={setItem}
        setStatus={setStatus}
        setSearch={setSearch}
        setYear={setYear}
        cleanSearches={cleanSearches}
        doSearches={doSearches}
        handleChange={handleChange}
      />
    </Container>
  );
};

export default ControleProjetos;
